import 'react-datepicker/dist/react-datepicker.css';
import { Box, FormControl, Input, Select, Textarea, FormLabel, FormHelperText, useColorModeValue } from '@chakra-ui/react';

// Assets
import { formatDate } from 'services/Utils';

// Components
import { DateTimeInputIcon } from 'components/Icons/Icons';

const EditSelect = ({ 
  id, 
  options, 
  label,
  value, 
  editMode,
  isValid, 
  onChange, 
  placeholder = '',
  ...restProps
}) => {
  const bgColor = useColorModeValue('white !important', '#0A1027 !important');
  const border = useColorModeValue('1px solid #CBE7FF !important', '1px solid #262D47 !important');
  const editLineBgDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const editLineBgWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const editLineBg = useColorModeValue(editLineBgWhite, editLineBgDark);

  return (
    <FormControl variant={editMode ? 'floating' : 'calm'} className={!editMode ? 'edit-mode' : ''}>
        <Select 
        	bg={bgColor} 
        	border={ editMode ? border : 'unset'} 
        	_focus={{
        		border
        	}}
        	h="56px !important" 
        	id={id} 
        	pointerEvents={editMode ? 'unset' : 'none'}
        	placeholder={placeholder} 
        	value={value} 
        	onChange={onChange} className={isValid ? 'input-valid' : 'input-invalid'}>
            { options?.map((option, index) => (
            	<option key={index} value={option.value}>{option.title}</option>
            ))}
        </Select>
        <FormLabel htmlFor={id} className={isValid ? 'input-valid' : 'input-invalid'}>{label}</FormLabel>
        <FormHelperText className={isValid ? 'hidden' : 'input-error' }>Input invalid</FormHelperText>

        { editMode && (
	        <Box
	        	zIndex="1"
		        transition="0.2s all"
		        opacity={ value?.length > 0 ? '1' : '0'}
		        w="100%"
		        position="absolute"
		        bottom="0"
		        h="2px" 
		        bg={editLineBg} />
	    )}
    </FormControl>
  );
};

export default EditSelect;






